var path = 'batch/metadataRestore/navigator/metadataRestoreNavigator.tpl.html';
var html = "<react-component name='metadata-restore-navigator' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;